import BulletCard from "./BulletCard"
import paper from "../Assets/paper.png"

const AdvantageCard=({title,bulletdata})=>
{
    return(
        <div  className="sm:mb-[30px] lg:mb-[0px] px-[30px] sm:py-[20px] bg-white lg:pt-[30px] lg:pb-[20px]">
            <p className="text-black font-[700] sm:text-[20px] lg:text-[22px] leading-[26px] sm:pb-[20px] lg:pb-[20px]">{title}</p>
            <div>
                {
                    bulletdata?.map((e,i)=>
                    {
                        return <BulletCard key={i} text={e} />
                    })
                }
            </div>
        </div>
    )
}
export default AdvantageCard

// style={{backgroundImage:`url(${paper})`,backgroundRepeat:"no-repeat",backgroundSize:"100% 100% ",boxShadow:"0px 3.31104px 26.4883px rgba(38, 22, 87, 0.1)"}}